import { Network } from "@aptos-labs/ts-sdk";
import { aptosNetwork } from "@src/api/aptos";

const getNetworkQueryParam = (): string => {
  const networkParamMap: Record<Network, string> = {
    [Network.TESTNET]: "?network=testnet",
    [Network.MAINNET]: "",
    [Network.DEVNET]: "?network=devnet",
    [Network.LOCAL]: "?network=local",
    [Network.CUSTOM]: "?network=custom",
    [Network.SHELBYNET]: "?network=shelbynet",
    [Network.NETNA]: "?network=netna",
  };

  return networkParamMap[aptosNetwork] ?? "";
};

export const openExplorer = (address: string) => {
  const baseUrl = "https://explorer.aptoslabs.com";
  const networkParam = getNetworkQueryParam();

  const url = `${baseUrl}/account/${address}${networkParam}`;
  window.open(url, "_blank");
};

export const openMarketExplorer = (marketAddress: string) => {
  const baseUrl = "https://explorer.aptoslabs.com";
  const networkParam = getNetworkQueryParam();

  const url = `${baseUrl}/object/${marketAddress}/resources${networkParam}`;
  window.open(url, "_blank");
};
